import React from 'react';

export default function Experience() {
    return <h2>This is the experience page!</h2>
}